import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { Flex } from '@withjoy/joykit';
import { ListValueProps } from '../ValueProps/ValueProps';
import { useDigitalValuePropSections } from './useDigitalValuePropSections';

export const DigitalValueProps = (props: BoxProps) => {
  const sections = useDigitalValuePropSections();

  return (
    <Flex
      flexDirection="column"
      rowGap={7}
      {...props}
    >
      {sections.map(section => (
        <ListValueProps
          key={section.key}
          sectionTitle={section.title}
          items={section.items.map(({ icon, title, description }) => ({ icon, title, description }))}
        />
      ))}
    </Flex>
  );
};
